export const AGE_GATE_COOKIE_KEY = "__age_verified__";
export const AGE_GATE_MAX_AGE_DAYS = 180;
export const AGE_GATE_VERSION = 1;

